import React, {useEffect, useState} from 'react'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import DateRangeSelector from '../filterDataRange/DateRangeSelector';
import userimg from "../../../assets/images/user.png";
import { EXLDownloadIcon, PDFDownloadIcon } from '../../../SvgIconsData';
import LearningProductivity from './Charts/LearningProductivity';
import axios from 'axios';
import LatestResult from '../user/LatestResult';
import ActiveCourses from '../user/ActiveCourses';
import GameEngagement from '../user/GameEngagement';
import Completed from '../user/Completed';


const LMSUserDashboard = () => {
  const location = useLocation();
  var navigate = useNavigate();
  const params = useParams();
  const { uuid } = params;
  const userData = useSelector((state) => state.userSlice);
  if (!location.state || !location.state.uuid) {
    navigate(`/2d/lms/dashboard/${userData.user.uuid}`, { state: userData.user });
  }
  const configData = useSelector((state) => state.configSlice);
  const[loading, setLoading] = useState(true)
  const [filter, setFilter] = useState("all");
  const [isHome, setIsHome] = useState(true);
  const [labels, setWeekdays] = useState([]);
  const [skillStreamCounts, setSkillStreamCounts] = useState([]);
  const [analytics, setUserAnalytics] = useState({
    weekCounts: {
      all: 0,
      skillStream: 0,
    },
    modules: [],
    totalCounts: {
      all: 0,
      skillStream:0
    },
  });


  useEffect(() => {
    if (window.location.pathname.startsWith("/team/user/") || window.location.pathname.startsWith("/2d/lms/team/user/") ) {
      setIsHome(false);
    }
  }, []);


  const getUserAnalytics = async () => {
    setLoading(true);
    try {
      const userAnalytics = await axios.get(`${configData.config.API_URL}/api/dashboard/user/${configData.config.MODE}/${uuid}?filter=${filter}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          }}
      );

      setUserAnalytics(userAnalytics.data);

    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };


  useEffect(() => {
    getUserAnalytics();
  }, [filter]);

  const { modules } = analytics;
  const tostart = modules;
  const ongoing = modules.sort((a, b) => {
    if (b.progress === 100) return -1;
    return b.progress - a.progress;
  });
  const completed = modules.sort((a, b) => {
    return b.progress - a.progress;
  });

  function extractData(analytics) {
    const labels = [];
    const skillStreamCounts = [];


    analytics?.forEach((day) => {
      labels.push(day.label);
      skillStreamCounts.push(day.counts.skillStream  );
    });

    return { labels, skillStreamCounts };
  }

  useEffect(() => {
    const { labels, skillStreamCounts } = extractData(analytics?.durationCounts);
    setWeekdays(labels);
    setSkillStreamCounts(skillStreamCounts);
  }, [analytics]);



  return (


    <div className="container-fluid bg-grey-main dashboard p-3 pt-2">
      <div className="row">
      <div className="col-md-6 d-flex align-items-center">
        
        {!isHome && <button
            className="backbtn cursor-pointer ps-2 mt-2"
            title="Back"
            onClick={() => navigate(-1)} >
            <FaArrowLeftLong />
            Back
          </button>
        }

      </div>
      <div className="col-md-6 d-flex align-itmes-center gap-2 atdash">
         <DateRangeSelector selected={filter} setSelected={setFilter} />
        {/* <>
            <button
              className="DefaultRedBtn download px-2"
              title="Download PDF"
              // onClick={() => exportMultipleChartsToPdf("User_Dashboard", tableData1, tableData2)}
              >
              <PDFDownloadIcon />
            </button>
            <button
              className="DefaultRedBtn download px-2"
              title="Download Excel"
              // onClick={() => generateExcel("User_Dashboard", tableData1, tableData2)}
              >
              <EXLDownloadIcon />
            </button>
            </> */}
      </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-12">
          <div className='datacardesign py-2'>
          <div className="row justify-content-between">
            <div className={isHome ? "col-md-5 " : "col-md-5 d-flex align-items-center "}>
             <div className='cardimages d-flex align-items-center'>
             {isHome ? 
                 <img src={userimg} className="defaultimagesdash" alt="" /> 
                  :
                location.state.avatar ? (
                      <div className="usercardesign m-0 ps-3" style={{ height: "auto" }}>
                      <div className='avatarimg ps-3'>
                        <img src={location.state.avatar} referrerPolicy={'no-referrer'} />
                      </div>
                      </div>
                    ) : (
                      <div className="usercardesign m-0 ps-3"  style={{ height: "auto" }}>
                      <div className='initials-placeholder abc'>
                        {location.state?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                      </div>
                      </div>
                    )
                  }
                  {isHome ?
                    <div className="welcometext ps-3">
                      <p> {loading ? ( <Skeleton width="20vw" /> ) : <> Welcome back ! </> }</p>
                      <h4>{loading ? ( <Skeleton width="25vw" /> ) : <>{location.state?.name} </> }</h4>
                    </div> :
                    <div className="welcometext notwelcome ps-3 pt-0 mt-0">
                      <h4>{location.state?.name}</h4>
                    </div>
                  }
             </div>
            </div>

            <div className="col-md-7">
            <div className="dashstatdata">
                  <div className="welcometext ">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Total Learning Duration </>} </p>
                    <h4>{loading ? <Skeleton width="5vw" /> :  analytics?.duration?.all?.sum?.humanReadable  }</h4>
                  </div>
                  <div className="welcometext">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Courses </>} </p>
                    <h4>{loading ? <Skeleton width="5vw" /> :  analytics?.playedModule}</h4>

                  </div>
                </div>
            </div>
          </div>
          </div>
        </div>
      </div>



      <div className="row mt-0">
        <div className=" col-lg-12 col-xl-9 col-xxl-9" >
          <div className="row mt-3">

            <div className="col-md-6">
              <LatestResult modules={ongoing}  loading={loading} />
            </div>

            <div className="col-md-6">
             <div className="cardbox overflow-hidden custom-chart">
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">{loading ? ( <Skeleton width="5vw" /> ) : <> Productivity </> }</h5>
                    <p className="mb-1">{loading ? ( <Skeleton width="5vw" /> ) :  <>Total Lessons :  {analytics.totalCounts.all} </> }</p>
                </div>
                <LearningProductivity 
                  labels={labels}
                  skillStreamCounts={skillStreamCounts}
                />
             </div>
            </div>
          </div>
          <ActiveCourses modules={tostart.slice(0, 3)} loading={loading}  />
        </div>

        <div className=" col-lg-12 col-xl-3 col-xxl-3">
          <div className="cardbox position-relative mt-3">
          
            <GameEngagement modules={analytics.modules} loading={loading}/>
            <Completed modules={completed} loading={loading}/>

          </div>
        </div>
      </div>

    </div>


  )
}

export default LMSUserDashboard
